import React, { useState, useEffect, useContext } from 'react'
import { canEdit, getProfileDetails } from '../Utility'
import Loader from '../../Loader'
import SubSectionHeader from '../../Shared/SubSectionHeader'
import classes from './FreightMasterMain.module.css'
import axios from '../../../Axios'
import { Urls } from '../../../Urls'
import NoAccess from '../NoAccess'
import { isMobile } from '../../../Constants'
import PopupModal from "../../Shared/PopupModal/PopupModal";
import ShowHistory from '../../Planning/components/ShowHistory'
import MastersRouting from './MastersRouting'
import { useHistory } from 'react-router-dom';
import { UserApiContext } from '../../UserDetailsContext/UserDetailsContext'
import { MyCompanyProfileContext } from '../../../MyCompanyProfileContext'
import { isSuperUser } from './FreightMaster/UploadExcel/Step1/utils'
import DownloadLogs from './DownloadLogs/DownloadLogs'
import { useMixPanelForTracking } from '../../../utils/TrackMixPanel'
import useViewOnlyAccess from '../../../hooks/useViewOnlyAccess'


const FreightMasterMain = () => {
    const {
        canAccess,
        hasModuleAccess,
        isRestricted,
        checkActionPermission,
        loading: accessLoading
    } = useViewOnlyAccess('masters')

    const [editMode, setEditMode] = useState(false)
    const [canedit, setcanedit] = useState(false)
    const [show, setshow] = useState(false)
    const [company_id, setCompany_id] = useState('')
    const [freightdata, setfreightData] = useState([])
    // const [showfreightMaster, setShowfreightMaster] = useState(true)
    // const [showLocationMaster, setShowLocationMaster] = useState(false)
    // const [showTruckMaster, setShowTruckMaster] = useState(false)
    // const [showOtherMaster, setShowOtherMaster] = useState(false)
    // const [showVendorMaster, setShowVendorMaster] = useState(false)
    const [activeTab, setActiveTab] = useState("freight")
    const { companyProfile, userDetails } = useContext(UserApiContext)
    const [selectedOrg, setSelectedOrg] = useState("company")
    const [orgList, setOrgList] = useState([])
    const [isOrgLevel, setIsOrgLevel] = useState(false)
    const history = useHistory();
    const { companySettingData } = useContext(MyCompanyProfileContext)
    const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData)

    useEffect(() => {
        var id = ''
        // var temp = {}
        document.title = 'Company Profile - Freight Master'
        if (companyProfile && companyProfile.domain_data && companyProfile.domain_data.company_id) {
            setCompany_id(companyProfile.domain_data.company_id)
        }

        const { pathname } = history.location;
        const tabName = pathname.split('/').pop().replace('master', '');
        if (tabName === 'route') {
            setActiveTab("material")
        } else {
            setActiveTab(tabName);
        }
    }, [companyProfile, history.location])

    useEffect(() => {
        if (companySettingData && companySettingData.contact_information) {
            const result = isSuperUser(companySettingData.contact_information, userDetails.email);
            if (result) {
                let finalOrgs = []
                // if(result.isSuperAdmin === true){
                //     if(companySettingData?.organizations && companySettingData.organizations.length > 0){
                //         finalOrgs = companySettingData.organizations.filter(item => !item.is_deleted)
                //     }
                //     console.log(finalOrgs,"finalOrgs");
                if (result.organizationList && result.organizationList.length > 0) {
                    setOrgList(result.organizationList)
                }
            }
        }
        if (companySettingData && companySettingData.masters_setting) {
            if (companySettingData.masters_setting.masters_show_level && companySettingData.masters_setting.masters_show_level === "organization_level") {
                setIsOrgLevel(true)
            }
        }
    }, [companySettingData])

    const saveDetails = () => {
        TrackMixPanel({
            ModuleName: 'masters',
            ScreenName: 'freight master',
            Definition: 'user has clicked on freight master view map button',
            Data: 'none'
        });
        getFreightData();
        setEditMode(true);
    };
    const getFreightData = () => {
        setshow(true)
        axios.get(`${Urls.freight_master}`)
            .then(res => {
                // console.log(res.data)
                setfreightData(res.data.data)
                var list = []
                res.data.data.map(item => {
                    return list.push(item?.transporter_details?.length)
                })
                setshow(false)
            })
            .catch(err => {
                console.log(err)
                setshow(false)
            })
    }

    const activeMaster = (activeTab) => {
        switch (activeTab) {
            case "freight":
                history.push({ pathname: '/companyprofilenew/masters/freightmaster' })
                setActiveTab("freight")
                break;
            case "location":
                history.push({ pathname: '/companyprofilenew/masters/locationmaster' })
                setActiveTab("location")
                break;
            case "truck":
                history.push({ pathname: '/companyprofilenew/masters/truckmaster' })
                setActiveTab("truck")
                break;
            case "vendor":
                history.push({ pathname: '/companyprofilenew/masters/vendormaster' })
                setActiveTab("vendor")
                break;
            case "material":
                history.push({ pathname: '/companyprofilenew/masters/materialmaster' })
                setActiveTab("material")
                break;
            default:
                console.error(`Unknown tab: ${activeTab}`);
                break;
        }
    }

    if (!accessLoading && !hasModuleAccess && company_id) {
        return (
            <div style={{ height: "79vh", display: 'flex', alignItems: 'center' }} className="row">
                <NoAccess show={true} />
            </div>
        )
    }

    return (
        <div>
            <Loader show={show || accessLoading} />
            <>
                <div className={isMobile() ? '' : `row m-0 w-100`} style={{ display: isMobile() ? 'flex' : '', flexDirection: isMobile() ? 'row' : '', padding: isMobile() ? '' : '1% 1% 1% 1.5%', alignItems: 'center' }}>
                    <div className={isMobile() ? '' : `col-lg-8 col-md-12`} style={{ flex: '1 1 auto' }}>
                        <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                            {/* <SubSectionHeader title="3. Freight Master" className={classes['title']}></SubSectionHeader> */}

                        </div>
                        <div className='row'>
                            <ul className="nav nav-tabs" id="myTab" role="tablist" style={{ paddingTop: "0.5%" }}>
                                <li className="nav-item">
                                    <div
                                        // className={`nav-link ${showDashboard === true && window.location.pathname === '/trucks/dashboard' ? 'active' : ''}`}
                                        className={`nav-link p-0 ${activeTab === "freight" ? 'active' : ''}`}
                                    >
                                        <div
                                            // to={{pathname:"/trucks/dashboard"}} 
                                            id="frieghtMaster"
                                            className="btn btn-link"
                                            onClick={e => activeMaster("freight", e)}
                                            style={{ cursor: 'pointer', color: '#393185', fontSize: isMobile() ? '14px' : '17px', fontWeight: 'bolder', padding: isMobile() ? '0' : '2px 10px' }}
                                        >
                                            Freight Master
                                        </div>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <div
                                        className={`nav-link p-0 ${activeTab === "location" ? 'active' : ''}`}
                                    >
                                        <div
                                            // to={{pathname:"/trucks/dashboard"}} 
                                            id="locationMaster"
                                            className="btn btn-link"
                                            onClick={e => activeMaster("location", e)}
                                            style={{ cursor: 'pointer', color: '#393185', fontSize: isMobile() ? '14px' : '17px', fontWeight: 'bolder', padding: isMobile() ? '0' : '2px 10px' }}
                                        >
                                            Location Master
                                        </div>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <div
                                        className={`nav-link p-0 ${activeTab === "truck" ? 'active' : ''}`}
                                    >
                                        <div
                                            // to={{pathname:"/trucks/dashboard"}} 
                                            id="truckMaster"
                                            className="btn btn-link"
                                            onClick={e => activeMaster("truck", e)}
                                            style={{ cursor: 'pointer', color: '#393185', fontSize: isMobile() ? '14px' : '17px', fontWeight: 'bolder', padding: isMobile() ? '0' : '2px 10px' }}
                                        >
                                            Truck Master
                                        </div>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <div
                                        className={`nav-link p-0 ${activeTab === "vendor" ? 'active' : ''}`}
                                    >
                                        <div
                                            // to={{pathname:"/trucks/dashboard"}} 
                                            id="vendorMaster"
                                            className="btn btn-link"
                                            onClick={e => activeMaster("vendor", e)}
                                            style={{ cursor: 'pointer', color: '#393185', fontSize: isMobile() ? '14px' : '17px', fontWeight: 'bolder', padding: isMobile() ? '0' : '2px 10px' }}
                                        >
                                            Vendor Master
                                        </div>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <div
                                        className={`nav-link p-0 ${activeTab === "material" ? 'active' : ''}`}
                                    >
                                        <div
                                            // to={{pathname:"/trucks/dashboard"}} 
                                            id="otherMaster"
                                            className="btn btn-link"
                                            onClick={e => activeMaster("material", e)}
                                            style={{ cursor: 'pointer', color: '#393185', fontSize: isMobile() ? '14px' : '17px', fontWeight: 'bolder', padding: isMobile() ? '0' : '2px 10px' }}
                                        >
                                            Other Masters
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* <div className={isMobile()?'' :`col-xs-3`} style={{flexBasis:'30%'}}>
                        {!editMode? 
                            <>
                                <button className={`btn btn-success mr-2`} onClick={saveDetails}>View Map</button> 
                            </>
                        :<button className={`btn btn-primary`} onClick={e => setEditMode(false)}><i className={`fa fa-edit`}/>Go Back</button>}    
                    </div> */}
                    {activeTab === "freight" && editMode && (
                        <div className="d-flex align-items-center" style={{ gap: "12px", paddingRight: "2%" }}>
                            <button className="btn btn-primary" onClick={e => setEditMode(false)}>
                                <i className="fa fa-edit mr-2" />
                                Go Back
                            </button>
                        </div>
                    )}
                    {/* {showfreightMaster === true ?
                            <>
                                <span className={isMobile() ? '' : ``} style={{ marginTop: '5%', marginLeft: '5%' }}>
                                    {!editMode ?
                                        <>
                                            <button className={`btn btn-success mr-2`} onClick={saveDetails}>View Map</button>
                                            <PopupModal
                                                id="upload-modal"
                                                buttonLabel={
                                                    <>
                                                        <i className="far fa-clock pr-2" style={{ fontSize: "15px" }}></i>
                                                        <span>Show Activity</span>
                                                    </>
                                                }
                                                buttonClass={`btn btn-info mr-2`}
                                                content={<ShowHistory screen_name='freight_master' />}
                                                screenName="LoRRI Planning"
                                                moduleName="Planning"
                                            />
                                        </>
                                        : <button className={`btn btn-primary`} style={{marginTop: '4%'}} onClick={e => setEditMode(false)}><i className={`fa fa-edit`} />Go Back</button>}
                                </span>
                                <span style={{ width: isMobile() ? '' : '95%', marginTop: isMobile() ? '' : '2.5%' }}>
                                    {!editMode ? <FreightMaster canedit={canedit} /> : <Map network1={freightdata} />}
                                </span>
                            </>
                    : showLocationMaster === true ?
                    <><LocationMaster /></>
                    : showTruckMaster === true ?
                    <><TruckMaster /></>
                    : showOtherMaster === true ?
                    <>
                    <div className='row col-md-12'>
                    <OtherMaster />
                    </div>
                    </>
                    : showVendorMaster === true ?
                    <><VendorMaster /></>
                    : ''
                } */}
                </div>
                <div className='col-md-12'>
                    <MastersRouting
                        editMode={editMode}
                        freightdata={freightdata}
                        orgList={orgList}
                        selectedOrg={selectedOrg}
                        canAccess={canAccess}
                        canUpdate={!isRestricted}
                        canedit={isRestricted}
                        checkActionPermission={checkActionPermission}
                        onViewMap={saveDetails}
                    />
                </div>
                {/* {showfreightMaster === true ? 
                    <>
                        <div className={isMobile()?'' :``} style={{flexBasis:'30%', textAlign: 'end', marginRight: '8%'}}>
                        {!editMode? 
                            <>
                                <button className={`btn btn-success mr-2`} onClick={saveDetails}>View Map</button> 
                            </>
                        :<button className={`btn btn-primary`} onClick={e => setEditMode(false)}><i className={`fa fa-edit`}/>Go Back</button>}    
                        </div>
                        <div style={{width:isMobile()? '':'90%', marginTop:isMobile()? '':'3%', marginLeft:isMobile()?'':'3%'}}>
                            {!editMode ? <FreightMaster canedit={canedit}/> : <Map network1={freightdata}/>}
                        </div>
                    </> 
                    : showLocationMaster === true ?
                    <><LocationMaster /></> 
                    : showTruckMaster === true ? 
                    <><TruckMaster /></>
                    : showOtherMaster === true ?
                    <><OtherMaster /></>
                    : ''
                } */}
            </>
        </div>
    )
}
export default FreightMasterMain
